
export const postVideoUpload = (formUrl, formData) => {
  const options = {
    method: 'POST',
    body: formData,
  };

  return new Promise((resolve, reject) => {
    fetch(formUrl, options)
    .then(res => {
      resolve(res.json());
    })
    .catch(function(error){
      reject(error);
    })
  });
}

/**
 * Load up the settings for the current session
 */
export const getSettings = () => {

  return new Promise((resolve, reject) => {

    const activeCountry = typeof(window.Shopify) !== 'undefined' && window.Shopify.country ? window.Shopify.country : null;

    let url = `${window.Shopify?.routes?.root}a/gc/api/settings?locale=${window?.Shopify?.locale}`;

    if (activeCountry) {
      url += `&country=${activeCountry}`;
    }

    fetch(url)
    .then(res => {
      return res.json();
    })
    .then((settings) => {

      resolve(settings);

    })
    .catch((error) => {
      console.log(error);
      reject(error);

    })
    ;

  });

}
